import moment from 'moment';
import { isEmpty } from 'lodash';

export const timestampTodate = (timestamp, language) => {
    if (timestamp === 0) return null;
    if (language === 'th')
        return moment(timestamp).add(543, 'year').format('Do MMM YYYY, HH:mm')
    if (language === 'cn')
        return moment(timestamp).format('YYYY MMM Do, HH:mm')
    else
        return moment(timestamp).format('MMM Do YYYY, HH:mm')
}

export const durationToTime = (milliseconds) => {
    if (parseInt(milliseconds) >= 3600000) {
        return moment.utc(moment.duration(milliseconds).asMilliseconds()).format("HH:mm:ss");
    } else {
        return moment.utc(moment.duration(milliseconds).asMilliseconds()).format("mm:ss");
    }
}

export const dateToMillisecond = (date) => {
    if (moment(date, "MM/DD/YYYY HH:mm").format("MM/DD/YYYY HH:mm") === date) {
        return moment(date, "MM/DD/YYYY HH:mm").valueOf()
    }
    return null
}

export const convertWithDutationTime = (date, hours, minutes) => {
    return moment(date, "MM/DD/YYYY HH:mm")
        .add(hours, 'hours')
        .add(minutes, 'minutes')
        .valueOf()
}

export const disabledPastDay = (current) => {
    let customDate = moment().format('YYYY-MM-DD');
    return current && current < moment(customDate, "YYYY-MM-DD");
}

export const disabledPastHours = () => {
    var hours = [];
    for (let i = 0; i < moment().hour(); i++) {
        hours.push(i);
    }
    return hours;
}

export const disabledPastMinutes = (selectedHour) => {
    var minutes = [];
    if (selectedHour === moment().hour()) {
        for (var i = 0; i < moment().minute(); i++) {
            minutes.push(i);
        }
    }
    return minutes;
}


export const convertMillisecondToDate = (milliseconds) => {
    if (milliseconds) {
        return moment(milliseconds).format("YYYY-MM-DD HH:mm")
    }
    return null
}

export const dateDiffDuration = (startMillisecond, endMillisecond) => {
    if (startMillisecond && endMillisecond) {
        let start = moment(startMillisecond);
        let end = moment(endMillisecond);
        let duration = moment.duration(end.diff(start));
        let hours = Math.floor(duration.asHours());
        let minutes = Math.floor(duration.minutes())
        return {
            hours, minutes
        }
    }
    return {
        hours: null,
        minutes: null
    }
}

export const secondsContextToHms = (token) => {
    if (!isEmpty(token)) {
        let tokenString = new Buffer(token, 'base64').toString()
        let contextTime = JSON.parse(tokenString)
        let timeSecond = contextTime.r.d

        let second = Number(timeSecond);
        let hours = Math.floor(second / 3600);
        let minutes = Math.floor(second % 3600 / 60);

        return {
            hours,
            minutes
        }
    }
    return {
        hours: 0,
        minutes: 0
    }
}

export const getTimeRemaining = (startTime) => {
    const total = startTime - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
        total,
        days,
        hours,
        minutes,
        seconds
    };
}